import Form from './Form';
import Captcha from './Captcha';

class Sellsy {
	constructor() {
		this.forms = document.querySelectorAll('form[class^="form_contact"]');
		this.forms.forEach((form) => new SellsyForm(form));
	}
}

export class SellsyForm {
	constructor(form) {
		this.build(form);

		this.form = new Form(form, {
			submitSelector: 'button.cta',
			preventSubmit: false,
		});
	}

	build(form) {
		if (form.hasChildNodes()) {
			const formParentElement = form.parentElement;
			const formWrapper = document.createElement('div');
			formWrapper.classList.add('form-wrapper');
			formWrapper.style.fontSize = '14px';
			formParentElement.removeChild(form);
			formWrapper.appendChild(form);
			formParentElement.appendChild(formWrapper);

			while (form.querySelector(':scope > label')) {
				const label = form.querySelector(':scope > label');
				if (label) {
					const inputWrapper = document.createElement('div');
					const previousElement = label.previousElementSibling;
					const nextElement = label.nextElementSibling;
					const nextElementTagName = nextElement.tagName.toLowerCase();

					const checkbox = label.querySelector('input[type="checkbox"], input[type="radio"]');

					if (checkbox) {
						inputWrapper.appendChild(checkbox);
						label.htmlFor = checkbox.id;
						inputWrapper.appendChild(label);
						inputWrapper.classList.add('checkbox-wrapper');
					} else if (nextElementTagName === 'input' || nextElementTagName === 'textarea') {
						inputWrapper.appendChild(nextElement);
						inputWrapper.appendChild(label);
						inputWrapper.classList.add('input-wrapper');
					} else if (nextElementTagName === 'select') {
						inputWrapper.appendChild(label);
						inputWrapper.appendChild(nextElement);
						inputWrapper.classList.add('select-wrapper');
					} else {
						inputWrapper.appendChild(label);
						if (nextElementTagName !== 'label') {
							inputWrapper.appendChild(nextElement);
						} else {
							inputWrapper.classList.add('label-wrapper');
						}
					}

					previousElement.after(inputWrapper);
				}
			}
		}

		// Add CTA class to button
		const button = form.querySelector('a.btn');
		if (button) {
			button.classList.add('cta', 'cta--light-blue');
			button.classList.remove('btn');
		}

		const diagsSelect = form.querySelector('select[name="form_cf[114261][select][value]"]');
		if (diagsSelect) {
			diagsSelect.parentElement.style.display = 'none';
			const contactFormIDInput = form.querySelector('input[name="contact_form_id"]');
			if (contactFormIDInput) {
				const formID = contactFormIDInput.value;

				switch (formID) {
					case '5':
						diagsSelect.value = 'IRBI';
						break;
					case '6':
						diagsSelect.value = 'VOW';
						break;
					case '7':
						diagsSelect.value = 'TAN';
						break;
					default:
						break;
				}
			}
		}

		// if (this.submitButton) {
		// 	this.submitButton.style.display = 'none';

		// 	const button = document.createElement('button');
		// 	button.classList.add('cta', 'cta--light-blue');
		// 	button.innerHTML = this.submitButton.innerHTML;
		// 	form.appendChild(button);
		// }
	}
}

export default Sellsy;
